// App de celular (pasta ionic/, Capacitor — markdown/plano-app-mobile.md): o app abre este mesmo dashboard e a ponte
// nativa aparece em window.Capacitor. No navegador comum não existe, e tudo aqui fica desligado — por isso o front não
// depende de nenhum pacote do Capacitor.

interface NativeListener { remove: () => Promise<void> | void }
interface NativePlugin {
  addListener?: (event: string, cb: (data?: any) => void) => Promise<NativeListener> | NativeListener
  [method: string]: any
}
interface CapacitorBridge {
  isNativePlatform?: () => boolean
  getPlatform?: () => string
  Plugins?: Record<string, NativePlugin | undefined>
}

function bridge(): CapacitorBridge | null {
  return (window as unknown as { Capacitor?: CapacitorBridge }).Capacitor ?? null
}

/** Rodando dentro do app do celular (e não no navegador). */
export function isNativeApp(): boolean {
  return bridge()?.isNativePlatform?.() === true
}

/** android | ios dentro do app; nulo no navegador. */
export function nativePlatform(): string | null {
  return isNativeApp() ? bridge()?.getPlatform?.() ?? null : null
}

/** Um plugin nativo pelo nome (PushNotifications, Device, App…); nulo no navegador ou se o app não tiver o plugin. */
export function nativePlugin(name: string): NativePlugin | null {
  return isNativeApp() ? bridge()?.Plugins?.[name] ?? null : null
}

/** Chama cb quando o app volta do segundo plano (o sistema costuma derrubar a conexão nesse meio-tempo). Devolve como parar. */
export function onAppResume(cb: () => void): () => void {
  const app = nativePlugin('App')
  if (!app?.addListener) return () => undefined
  let listener: NativeListener | null = null
  let stopped = false
  void Promise.resolve(app.addListener('resume', () => cb())).then(l => {
    if (stopped) void l.remove()
    else listener = l
  })
  return () => {
    stopped = true
    void listener?.remove()
  }
}

/** Fabricante + modelo do celular ("Samsung SM-M526B"), pra listas de aparelhos; nulo fora do app. */
export async function nativeDeviceModel(): Promise<string | null> {
  try {
    const info = await nativePlugin('Device')?.getInfo?.()
    return [info?.manufacturer, info?.model].filter(Boolean).join(' ') || null
  } catch {
    return null
  }
}

/** Chama cb quando o app vai pro segundo plano (trava do app: conta o tempo fora). Devolve como parar. */
export function onAppPause(cb: () => void): () => void {
  const app = nativePlugin('App')
  if (!app?.addListener) return () => undefined
  let listener: NativeListener | null = null
  let stopped = false
  void Promise.resolve(app.addListener('pause', () => cb())).then(l => {
    if (stopped) void l.remove()
    else listener = l
  })
  return () => {
    stopped = true
    void listener?.remove()
  }
}
